<template>
  <div>
    <h1>{{article.title}}</h1>
    <div class="article-body" v-html="article.body"></div>
  </div>
</template>

<script>
import { getSpecificArticleFromStore } from '@/utils/common'

export default {
  props: [
    'articleIdProp'
  ],
  data() {
    return {
      articleId: ''
    }
  },
  created () {
    if (!this.articleIdProp) {
      this.fetchIdFromHash()
      return
    }
    this.articleId = this.articleIdProp
  },
  methods: {
    fetchIdFromHash () {
      let hash = this.$route.hash
      let hashSplit = this.$route.hash.split('#')
      if (!hash || hashSplit.length <= 0) {
        this.$router.push('home')
      }
      this.articleId = hashSplit[1].split('-')[0]
    }
  },
  computed: {
    article() {
      return getSpecificArticleFromStore(this.articleId)
    }
  },
  watch: {
    '$route.hash'() {
      this.fetchIdFromHash()
    }
  }
}
</script>

<style scoped>
.article-body a{
  color: #3bb4ef !important;
  font-weight: 400;
  text-decoration: none;
}

</style>
